function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Timing, { TimingPayload } from "./timing";
export default class Dosage {
  static fromPayload(payload) {
    let timing;
    let doseQuantity;
    if (payload.timing) {
      timing = new Timing(payload.timing);
    }
    if (payload.doseQuantity) {
      doseQuantity = parseFloat(payload.doseQuantity.toString());
    }
    return new Dosage({
      timing,
      doseQuantity
    });
  }
  constructor({
    timing,
    doseQuantity
  }) {
    _defineProperty(this, "timing", void 0);
    _defineProperty(this, "doseQuantity", void 0);
    this.timing = timing;
    this.doseQuantity = doseQuantity;
  }
  isEqual(other) {
    if (this == other) return true;
    let result = this.doseQuantity == other?.doseQuantity;
    if (this.timing) {
      result &&= this.timing.isEqual(other?.timing);
    }
    return result;
  }
  get jsonPayload() {
    const payload = {};
    if (this.timing) {
      payload.timing = this.timing.jsonPayload;
    }
    if (this.doseQuantity) {
      payload.doseQuantity = this.doseQuantity;
    }
    return payload;
  }

  /**
   * Returns true if the dosage period is more than one month (i.e. 2 months / 4 months),
   * or if "autre" dropdown possibility have been chosen.
   */
  get moreThanOneMonthOrOther() {
    if (!this.timing) return false;
    if (this.timing.period == null) return false;
    return this.timing.period > 1 && this.timing.periodUnit == "mo" || this.timing.periodUnit == "";
  }
}